<template>
  <ContainerScrolling class="SubjectDashboard">
    <LayoutFill :no-gutters="solidHeader" :no-padding="solidHeader">
      <MainBanner
        :subject="selectedSubject"
        :solid-header="solidHeader"
        :rss-feed="true"
        :search="true"
      />
    </LayoutFill>
    <LayoutGutters>
      <v-row class="mt-md-4">
        <ArticleMostPopular
          id="most-read-content"
          :selected-article="selectedSubject.mostReadItem"
          :title="articleMostReadTitle"
          :show-content-type="showContentTypeSubject"
        />
        <ArticleMostPopular
          v-if="showMostCitedItem"
          id="most-cited-content"
          :selected-article="selectedSubject.mostCitedItem"
          :title="articleMostCitedTitle"
          :show-content-type="showContentTypeSubject"
        />
      </v-row>

      <v-row mt-4>
        <v-col>
          <SelectedArticles
            title="Latest Content"
            :articles="selectedSubject.latestItems"
            :show-content-type="showContentTypeSubject"
            :show-large-title="false"
          />
        </v-col>
      </v-row>
      <v-row mt-4 mb-4>
        <v-col>
          <v-div text-center>
            <v-btn
              class="toLatestListing"
              outlined
              rounded
              @click="viewMoreRedirect"
            >
              View More
              <span class="d-sr-only"
                >&nbsp;Latest Content in {{ selectedSubject.name }}</span
              >
            </v-btn>
          </v-div>
        </v-col>
      </v-row>
    </LayoutGutters>
  </ContainerScrolling>
</template>

<script>
import { mapState } from "vuex";
import buildActionDispatcher from "~/actions/utilities/buildActionDispatcher";

import ContainerScrolling from "~/components/layout/ContainerScrolling.vue";
import LayoutFill from "~/components/layout/LayoutFill.vue";
import LayoutGutters from "~/components/layout/LayoutGutters";

import MainBanner from "~/components/banner/MainBanner.vue";
import SelectedArticles from "~/components/articles/SelectedArticles.vue";
import ArticleMostPopular from "~/components/articles/ArticleMostPopular.vue";

import toCanonicalUrl from "~/plugins/utilities/toCanonicalUrl.js";
import getPageTitle from "~/plugins/utilities/getPageTitle.js";
import getSiteName from "~/plugins/utilities/getSiteName.js";
import mapFlags from "~/plugins/utilities/mapFlags";

export default {
  name: "SubjectDashboard",
  components: {
    ContainerScrolling,
    LayoutFill,
    LayoutGutters,
    MainBanner,
    SelectedArticles,
    ArticleMostPopular,
  },
  data() {
    return {
      articleMostReadTitle: "Most Read",
      articleMostCitedTitle: "Most Cited",
    };
  },
  fetch: buildActionDispatcher("loadSubjectDashboard"),
  head() {
    const { selectedSubject, siteName, domain, partner } = this;

    const title = getPageTitle(siteName);
    const pageTitle =
      selectedSubject.name + " | Early Research Outputs | " + title;
    const cupTechText =
      this.partner === "chemrxiv"
        ? "technology provided by"
        : "brought to you by";

    const canonicalUrl = toCanonicalUrl(
      `subject-dashboard/${selectedSubject.id}`,
      partner
    );

    return {
      title: pageTitle,

      meta: [
        {
          hid: "description",
          name: "description",
          content: `Browse ${selectedSubject.name} to discover early research outputs in ${domain} on ${siteName}, ${cupTechText} Cambridge University Press.`,
        },
      ],
      link: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  computed: {
    ...mapState({
      layout: (state) => state.theme.layout,
      siteName: (state) => getSiteName(state.theme),
      domain: (state) => state.theme.domain,
      selectedSubject: (state) => state.selectedSubject,
    }),
    ...mapFlags(["showContentTypeSubject"]),
    partner() {
      return this.$config.partner;
    },
    solidHeader() {
      return this.layout.mainBannerSolidHeader;
    },
    showMostCitedItem() {
      return this.selectedSubject.mostCitedItem?.citationsCount;
    },
  },
  methods: {
    viewMoreRedirect() {
      const redirectPath = `/engage/${this.partner}/search-dashboard?subjects=${this.selectedSubject.id}&sortBy=PUBLISHED_DATE_DESC`;
      return this.$router.push(redirectPath);
    },
  },
};
</script>
